import React, {useRef, useState} from 'react'
import { AppBar,Box,Toolbar,Typography,Button,IconButton,Tooltip } from '@mui/material'
import PreviewIcon from '@mui/icons-material/Preview';
import DataObjectIcon from '@mui/icons-material/DataObject';
import LayersClearIcon from '@mui/icons-material/LayersClear';
import {useSurveyStore} from '../surveyutilities/surveyStore';
import CustomDialog from '../editorparts/smallcomponents/CustomDialog.jsx'


function EcxSurveyTopbar({onSave,onPublish}) {
    const exportToJSON = useSurveyStore((state)=>state.exportToJSON);
    const [jsonContent,setJsonContent]=useState(null);
    const dialogRef = useRef();

    const handleExportJson = ()=>{
        setJsonContent(exportToJSON());
        dialogRef.current.handleOpen();

    }
    const handlePreview = ()=>{}
    const handleResetClick=()=>{}
    return (
        <>
            <Box sx={{flexGrow:1,mb:2}}>
                <AppBar position="static" style={{ borderRadius: 10}} sx={{border:0,boxShadow: 1}} color='transparent' >
                    <Toolbar sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                        {/* Left Section */}
                        <Typography variant="h6" component="div">
                            Survey Editor
                        </Typography>

                        {/* Right Section */}
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Tooltip title="Export JSON">
                                <IconButton color="inherit" onClick={handleExportJson}>
                                    <DataObjectIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Preview">
                                <IconButton color="inherit" onClick={handlePreview}>
                                    <PreviewIcon />
                                </IconButton>
                            </Tooltip>

                            <Tooltip title="Reset Canvas">
                                <IconButton color="inherit" onClick={handleResetClick}>
                                    <LayersClearIcon />
                                </IconButton>
                            </Tooltip>

                            {/* Show buttons only if callbacks exist */}
                            {onSave && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={onSave}
                                    sx={{ ml: 2 }}
                                >
                                    Save
                                </Button>
                            )}
                            {onPublish && (
                                <Button
                                    variant="contained"
                                    color="success"
                                    onClick={onPublish}
                                    sx={{ ml: 1 }}
                                >
                                    Publish
                                </Button>
                            )}
                        </Box>
                    </Toolbar>
                </AppBar>
            </Box>
            <CustomDialog
                ref={dialogRef}
                title="Export Json"
                onConfirm={() => alert("Confirmed!")}
            >
                {/* Display Json Object*/}
                <pre>{jsonContent && JSON.stringify(jsonContent,null,2)}</pre>
            </CustomDialog>
        </>
    )
}

export default EcxSurveyTopbar